export default "__VITE_ASSET__Vd6rYA9j__"